import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const invoiceotherdetailsApi = createApi({
  reducerPath: "invoiceotherdetailsApi",
  baseQuery,
  tagTypes: ["invoiceOtherInfo"],
  endpoints: (builder) => ({
// 🔹 Get single invoice by Id
getInvoiceOtherDetailsById: builder.query({
  query: ({ id, subId }) =>
    `import/invoice/otherDetails/${id}/${subId}`,

  transformResponse: (response) => {
    // You can safely return only what you need
    return response?.data ?? null;
  },

  providesTags: ["invoiceOtherInfo"],
}),

    
    // 🔹 Update invoiceBuyer by Id
    updateInvoiceOtherDetails: builder.mutation({
      query: ({id, dataId , ...data  }) => ({
        url: `import/invoice/otherDetails/${id}/${dataId}`,
        method: "PUT", // ✅ should be PUT, not GET
        body: { otherDetails:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["invoiceOtherInfo"],
    }),

  }),
});

export const {
  useGetInvoiceOtherDetailsByMasterIdQuery,
  useLazyGetInvoiceOtherDetailsByIdQuery,
  useUpdateInvoiceOtherDetailsMutation,
} = invoiceotherdetailsApi;
